export { default } from './Thumb';
